module.exports = __webpack_public_path__ + "img/en.0e9cb777.png";